/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.handleLazyBound = this.handleLazy.bind(this);
    this.handleLoadBound = this.handleLoad.bind(this);
    this.observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
          this.handleLazy();
        }
      });
    });
  }

  connectedCallback() {
    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    this.handleLazy();
    window.addEventListener('resize', this.handleLazyBound, true);
    this.observer.observe(this, { attributes: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleLazyBound, true);
    this.observer.disconnect();
    this.removeEventListener('load', this.handleLoadBound);
  }

  handleLazy () {
    const mql = window.matchMedia('(min-width: 750px)');
    if (mql.matches && this.classList.contains('medium-hide')) return;
    if (!mql.matches && this.classList.contains('small-hide')) return;
    if (this.complete || this.classList.contains('loaded')) return;
    
    this.wrapper.classList.add('loading');
    this.addEventListener('load', this.handleLoadBound, { once: true });
  }

  handleLoad() {
    const loaded = () => {
      this.classList.add('loaded');
      this.wrapper?.classList.remove('loading');
    };

    window.requestIdleCallback ? window.requestIdleCallback(loaded, { timeout: 150 }) : setTimeout(loaded);
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });
